import { Trans, useTranslation } from 'react-i18next'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { formatRelativeTimeWithIntl } from '@/shared/lib/format-relative-time'
import type { OrganizationAuditLog } from '@/features/organization-users/types/audit-log'

type OrganizationActivityDescriptionCellProps = {
  activity: OrganizationAuditLog
}

export function OrganizationActivityDescriptionCell({
  activity,
}: OrganizationActivityDescriptionCellProps) {
  return (
    <div className="min-w-0 text-sm font-medium break-words whitespace-normal">
      <Trans
        i18nKey={`organizationUsers:activities.list.${activity.eventType}.title`}
        values={{ ...activity.metadata, user: activity.user }}
        components={[<em key="0" />, <em key="1" />]}
      />
    </div>
  )
}

type OrganizationActivityActorCellProps = {
  activity: OrganizationAuditLog
}

export function OrganizationActivityActorCell({
  activity,
}: OrganizationActivityActorCellProps) {
  const userFullName =
    `${activity.user?.firstName ?? ''} ${activity.user?.lastName ?? ''}`.trim()
  const email = activity.user?.email

  if (email) {
    return (
      <div className="min-w-0 text-sm">
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="cursor-default border-0 bg-transparent p-0 text-start font-medium underline decoration-dotted decoration-muted-foreground/60 underline-offset-2"
            >
              {userFullName || '—'}
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="max-w-sm break-all">
            {email}
          </TooltipContent>
        </Tooltip>
      </div>
    )
  }

  return (
    <div className="min-w-0 text-sm">
      <span className="font-medium">{userFullName || '—'}</span>
    </div>
  )
}

type OrganizationActivityWhenCellProps = {
  activity: OrganizationAuditLog
}

export function OrganizationActivityWhenCell({
  activity,
}: OrganizationActivityWhenCellProps) {
  const { i18n } = useTranslation()
  return (
    <span className="text-xs text-muted-foreground tabular-nums whitespace-normal">
      {formatRelativeTimeWithIntl(activity.createdAt, i18n.language)}
    </span>
  )
}
